import {
  Box,
  CardBody,
  CardHeader,
  CardRoot,
  CardTitle,
  ExpandableSection,
  Heading,
  NON_BREAKING_SPACES,
  Skeleton,
  SkeletonText,
  VStack,
} from '@oaknorth/component-core-v2';
import { FormatValue, useTranslation } from '@oaknorth/util-intl';

import { ReleaseNote } from './types';

export function ReleaseNoteDisplayCard({ note }: { note: ReleaseNote }) {
  return (
    <CardRoot>
      <CardHeader>
        <Box as="span">
          <FormatValue value={new Date(note.date)} />
        </Box>
        <CardTitle>{note.title}</CardTitle>
      </CardHeader>
      <CardBody>
        <ExpandableSection collapsedHeight={150}>
          <Box
            dangerouslySetInnerHTML={{ __html: note.content }}
            css={{
              'h3, summary': {
                fontSize: 'md',
                fontWeight: 'bold',
                marginTop: 4,
                marginBottom: 2,
                userSelect: 'none',
              },
              ul: {
                marginInlineStart: 4,
              },
              li: {
                marginBottom: 2,
              },
              p: {
                marginBottom: 2,
              },
              'details:not(:last-of-type)': {
                marginBottom: 2,
              },
            }}
          />
        </ExpandableSection>
      </CardBody>
    </CardRoot>
  );
}

export function ReleaseNoteDisplayDivided({ note }: { note: ReleaseNote }) {
  const { i18n } = useTranslation();
  return (
    <VStack gap={6} alignItems="flex-start">
      <Heading size="lg" fontWeight="semibold">
        {note.title} ({i18n.format(new Date(note.date))})
      </Heading>
      <Box
        dangerouslySetInnerHTML={{ __html: note.content }}
        css={{
          'h3, summary': {
            fontSize: 'md',
            fontWeight: 'bold',
            marginTop: 4,
            marginBottom: 2,
            userSelect: 'none',
          },
          ul: {
            marginInlineStart: 4,
          },
          li: {
            marginBottom: 2,
          },
          p: {
            marginBottom: 2,
          },
          'details:not(:last-of-type)': {
            marginBottom: 2,
          },
        }}
      />
    </VStack>
  );
}

export const SKELETON_NOTE_CARD = (
  <CardRoot>
    <CardHeader>
      <Skeleton>{NON_BREAKING_SPACES}</Skeleton>
      <CardTitle>
        <Skeleton>{NON_BREAKING_SPACES}</Skeleton>
      </CardTitle>
    </CardHeader>
    <CardBody>
      <SkeletonText noOfLines={10} lineHeight={10} />
    </CardBody>
  </CardRoot>
);

export const SKELETON_NOTE_DIVIDED = (
  <VStack alignItems="flex-start">
    <Skeleton>{NON_BREAKING_SPACES}</Skeleton>
    <SkeletonText noOfLines={10} lineHeight={10} />
  </VStack>
);
